import { useState, useEffect } from "react";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { useTranslation } from "react-i18next";
import {
  obtenerListaProgramacionCamionesPorFecha,
  aprobarProgramacionCamiones,
  rechazarProgramacionCamiones,
} from "../../../api/api-programacion-camiones";
import {
  STRING_ID_TIPO_USUARIO_WEB,
  STRING_SUPER_ADMIN,
  STRING_ID_ROL_USUARIO_WEB,
} from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import moment from "moment";
import Calendar from "../../../components/calendar";
import KanbanSolicitudColumn from "../../../components/kanban-solicitud-column";
import ModalConfigAccionesSolicitudKanban from "../../../components/modal-config-acciones-solicitud-kanban";
import DetalleRequerimientoViajeComponent from "../../../components/detalle-requerimiento-viaje-component";
import {
  crearConfigAccionesKanbanDefault,
  guardarConfigAccionesSolicitudKanban,
  notificarAccionSolicitudKanban,
  obtenerConfigAccionesSolicitudKanban,
  actualizarConfigAccionesSolicitudKanban,
} from "../../../api/api-kanban-config";

const SOLICITUD_COLUMN_ID = "solicitud-programacion-camiones";

const parseSolicitudItem = (row) => {
  let respuestasParsed = [];
  try {
    if (
      typeof row?.respuestas === "string" &&
      row.respuestas.trim().length > 0
    ) {
      respuestasParsed = JSON.parse(row.respuestas);
    } else if (Array.isArray(row?.respuestas)) {
      respuestasParsed = row.respuestas;
    }
  } catch (err) {
    console.log("parseSolicitudItem err");
    console.log(err);
  }
  return {
    ...row,
    respuestasParsed,
  };
};

export default function ListarEstadoSolicitudProgramacionCamionesPage() {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [btnBuscar, setBtnBuscar] = useState(false);
  // const [btnNuevo, setBtnNuevo] = useState(false);
  // const [btnModificar, setBtnModificar] = useState(false);
  // const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
  // const [btnHabilitar, setBtnHabilitar] = useState(false);
  // const [btnExportar, setBtnExportar] = useState(false);

  const [
    listaFormularioProgramacionCamiones,
    setListaFormularioProgramacionCamiones,
  ] = useState([]);
  const [listaRequerimientoProducto, setListaRequerimientoProducto] = useState(
    [],
  );
  const [accionesConfig, setAccionesConfig] = useState(
    crearConfigAccionesKanbanDefault,
  );
  const [modalConfigVisible, setModalConfigVisible] = useState(false);

  // Toast only (success / error messages)
  const { showToast } = useToast();
  // Processing overlay only (loading while API runs)
  const { showProcessing, hideProcessing } = useProcessing();

  const [fechaInicio, setFechaInicio] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [fechaFin, setFechaFin] = useState(
    moment().endOf("week").format("YYYY-MM-DD"),
  );

  useEffect(() => {
    iniciar();
  }, []);

  const buildlistaFormularioProgramacionCamiones = (solicitudes) => {
    return [
      {
        columnId: SOLICITUD_COLUMN_ID,
        title: null,
        items: solicitudes,
      },
    ];
  };

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado =
        habilitadoSelected !== null ? habilitadoSelected.value : null;
      objEnviar.fechaInicio = `${fechaInicio} 00:00:00`;
      objEnviar.fechaFin = `${fechaFin} 23:59:59`;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        // setBtnNuevo(true);
        // setBtnModificar(true);
        // setBtnDeshabilitar(true);
        // setBtnHabilitar(true);
        // setBtnExportar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find((p) => p.id === 8);
            if (manage !== undefined && manage !== null) {
              const permisosPage = manage.subMenu.find(
                (p) =>
                  p.value ===
                  PAGE_ID.GESTIONAR_RESPUESTA_SOLICITUD_PROGRAMACION_CAMIONES,
              );
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(
                (a) => a.value === "btn_buscar",
              );
              // const permisoBtnNuevo = permisosPage.acciones.find(a => a.value === 'btn_nuevo');
              // const permisoBtnModificar = permisosPage.acciones.find(a => a.value === 'btn_modificar');
              // const permisoBtnDeshabilitar = permisosPage.acciones.find(a => a.value === 'btn_deshabilitar');
              // const permisoBtnHabilitar = permisosPage.acciones.find(a => a.value === 'btn_habilitar');
              // const permisoBtnExportar = permisosPage.acciones.find(a => a.value === 'btn_exportar');
              setBtnBuscar(permisoBtnBuscar?.checked);
              // setBtnNuevo(permisoBtnNuevo?.checked);
              // setBtnModificar(permisoBtnModificar?.checked);
              // setBtnDeshabilitar(permisoBtnDeshabilitar?.checked);
              // setBtnHabilitar(permisoBtnHabilitar?.checked);
              // setBtnExportar(permisoBtnExportar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        const [listaProgramacionCamiones, responseConfig] = await Promise.all([
          obtenerListaProgramacionCamionesPorFecha(objEnviar, false, t),
          obtenerConfigAccionesSolicitudKanban(),
        ]);
        const solicitudes = listaProgramacionCamiones.map(parseSolicitudItem);
        setListaFormularioProgramacionCamiones(
          buildlistaFormularioProgramacionCamiones(solicitudes),
        );
        // console.log('responseConfig');
        // console.log(responseConfig);
        setAccionesConfig(responseConfig.data);
      }
    } catch (err) {
      console.log("iniciar err");
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleSolicitudCardClick = (item) => {
    setElementoSelected(item);
  };

  const handleDetalleSaved = (updatedItem) => {
    setElementoSelected(updatedItem);
    setListaFormularioProgramacionCamiones((prev) =>
      prev.map((column) => ({
        ...column,
        items: (column.items || []).map((card) =>
          String(card.id) === String(updatedItem.id) ? updatedItem : card,
        ),
      })),
    );
  };

  const recargarListaProgramacionCamiones = async (selectedItemId) => {
    const objEnviar = {
      habilitado: habilitadoSelected?.value ?? null,
      fechaInicio: `${fechaInicio} 00:00:00`,
      fechaFin: `${fechaFin} 23:59:59`,
    };

    const listaProgramacionCamiones =
      await obtenerListaProgramacionCamionesPorFecha(objEnviar, false, t);
    const solicitudes = listaProgramacionCamiones.map(parseSolicitudItem);

    setListaFormularioProgramacionCamiones(
      buildlistaFormularioProgramacionCamiones(solicitudes),
    );
    setElementoSelected(
      solicitudes.find(
        (solicitud) => String(solicitud.id) === String(selectedItemId),
      ) ?? null,
    );
  };

  const executeConfiguredAction = async (action, item) => {
    const config = accionesConfig[action];

    showProcessing();
    const response =
      action === "aceptar"
        ? await aprobarProgramacionCamiones({ id: item.id })
        : await rechazarProgramacionCamiones({ id: item.id });

    if (response.error === true) {
      hideProcessing();
      showToast(response.message || t("alert_no_se_pudo_crear"), "error", 3000);
      return;
    }

    await recargarListaProgramacionCamiones(item.id);
    hideProcessing();

    showToast(
      config?.mensaje ||
        (action === "aceptar"
          ? t("alert_solicitud_aceptada")
          : t("alert_solicitud_rechazada")),
      action === "aceptar" ? "success" : "warning",
      3000,
    );

    notificarAccionSolicitudKanban({
      idKanban: SOLICITUD_COLUMN_ID,
      idAccion: action,
      item,
    }).then((resultado) => {
      if (resultado.error) {
        showToast(
          `${t("alert_no_se_pudo_enviar_notificacion") || "No se pudo enviar la notificación"}: ${resultado.message ?? ""}`,
          "warning",
          3500,
        );
      }
    });
  };

  const handleSaveConfig = async (config) => {
    const payload = {
      ...config,
      id: accionesConfig?.id ?? null,
      idKanban: SOLICITUD_COLUMN_ID,
    };
    showProcessing();
    const response = payload.id
      ? await actualizarConfigAccionesSolicitudKanban(payload)
      : await guardarConfigAccionesSolicitudKanban(payload);
    hideProcessing();
    if (response.error === false) {
      setAccionesConfig(response.data);
      setModalConfigVisible(false);
      showToast(t("label_guardar"), "success", 2000);
      return;
    }
    showToast(response.message, "error", 3000);
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">
                  {t(
                    "label_gestionar_respuesta_solicitud_programacion_camiones",
                  )}
                </h2>
              </div>
              <p className="text-sm text-gray-500">
                {t(
                  "label_administra_la_lista_de_estado_solicitud_programacion_camiones",
                )}
              </p>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t("label_fecha_inicio")}
              </label>
              <Calendar
                value={fechaInicio}
                onChange={(date) => setFechaInicio(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_inicio"
                name="fecha_inicio"
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t("label_fecha_fin")}
              </label>
              <Calendar
                value={fechaFin}
                onChange={(date) => setFechaFin(date)}
                placeholder={t("placeholder_seleccione_fecha")}
                id="fecha_fin"
                name="fecha_fin"
              />
            </div>
            {btnBuscar === true && (
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label
                  className="block text-[#0F3457] font-semibold mb-2"
                  htmlFor="habilitado"
                >
                  &nbsp;
                </label>
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => {
                    reset();
                  }}
                >
                  {t("label_buscar")}
                </button>
              </div>
            )}
          </div>
          <br />
          <div className="grid grid-cols-12 gap-4 items-start">
            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
              {listaFormularioProgramacionCamiones.map((column) => (
                <KanbanSolicitudColumn
                  key={column.columnId}
                  columnId={column.columnId}
                  title={t("label_formulario_programacion_camiones")}
                  items={column.items}
                  onCardClick={handleSolicitudCardClick}
                  onAcceptCard={(item) =>
                    executeConfiguredAction("aceptar", item)
                  }
                  onRejectCard={(item) =>
                    executeConfiguredAction("rechazar", item)
                  }
                  onConfigureActions={() => setModalConfigVisible(true)}
                  selectedItemId={elementoSelected?.id ?? null}
                  emptyLabel={t("label_sin_datos")}
                />
              ))}
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-8 xl:col-span-8">
              <div className="bg-white border border-gray-200 rounded-lg p-4 min-h-[300px]">
                <DetalleRequerimientoViajeComponent
                  item={elementoSelected}
                  onSaved={handleDetalleSaved}
                />
              </div>
            </div>
          </div>
          <br />

          <ModalConfigAccionesSolicitudKanban
            isOpen={modalConfigVisible}
            initialConfig={accionesConfig}
            onCancel={() => setModalConfigVisible(false)}
            onSave={handleSaveConfig}
          />
        </div>
      );
    } catch (err) {
      console.log("ListarPais render err");
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  };

  return render();
}
